import React, { useState, useEffect } from 'react';
import './AdminDashboard.css';
import ManagementCard from '../../components/ManagementCard/ManagementCard';
import Modal from '../../components/Modal/Modal';

const AdminDashboard = () => {
    const [modalData, setModalData] = useState({
        isVisible: false,
        message: '',
        type: '',
    });

    useEffect(() => {
        const showModal = localStorage.getItem('show_modal');
        localStorage.removeItem('u-lastname');
        localStorage.removeItem('u-faculty');
        localStorage.removeItem('u-rank');
        localStorage.removeItem('u-number');
        localStorage.removeItem('cur-u-page');

        if (showModal === 'true') {
            setModalData({
                isVisible: true,
                message: 'ادمین عزیز شما با موقیت وارد شدید',
                type: 'success',
            });
        }
    }, []);

    return (
        <>
            <div className="dashboard-container container" >
                <ManagementCard title={'مدیریت کاربران'} methods={['لیست کاربران', 'اضافه کردن کاربران']} href_list={['/admin/user-management', '/admin/add-user']} name_list={['', '']} />
            </div>
            <Modal
                message={modalData.message}
                type={modalData.type}
                isVisible={modalData.isVisible}
                onClose={() => setModalData({ ...modalData, isVisible: false })}
            />
        </>
    );
};

export default AdminDashboard;

